'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = _interopDefault(require('tslib'));
var ioc = _interopDefault(require('@tsdi/ioc'));
var stream = _interopDefault(require('stream'));
var platformServer = _interopDefault(require('@tsdi/platform-server'));
var fs = _interopDefault(require('fs'));
var path = _interopDefault(require('path'));
var shelljs = _interopDefault(require('shelljs'));
var globby = _interopDefault(require('globby'));
var boot = _interopDefault(require('@tsdi/boot'));
var activities = _interopDefault(require('@tsdi/activities'));
var minimist = _interopDefault(require('minimist'));
var del = _interopDefault(require('del'));
var components = _interopDefault(require('@tsdi/components'));
var child_process = _interopDefault(require('child_process'));
var unit = _interopDefault(require('@tsdi/unit'));
var unitConsole = _interopDefault(require('@tsdi/unit-console'));
var rxjs = _interopDefault(require('rxjs'));
var operators = _interopDefault(require('rxjs/operators'));
var chokidar = _interopDefault(require('chokidar'));
var rollup = _interopDefault(require('rollup'));
var typescript = _interopDefault(require('typescript'));
var rollupPluginutils = _interopDefault(require('rollup-pluginutils'));
var annotations = _interopDefault(require('@tsdi/annotations'));
var gulpUglifyEs = _interopDefault(require('gulp-uglify-es'));
var through2 = _interopDefault(require('through2'));
var gulpJsonEditor = _interopDefault(require('gulp-json-editor'));
var jsonInPlace = _interopDefault(require('json-in-place'));
var gulpSourcemaps = _interopDefault(require('gulp-sourcemaps'));
var vinylFs = _interopDefault(require('vinyl-fs'));
var gulpTypescript = _interopDefault(require('gulp-typescript'));
var platformServerBoot = _interopDefault(require('@tsdi/platform-server-boot'));
var rollupPluginNodeResolve = _interopDefault(require('rollup-plugin-node-resolve'));
var rollupPluginSourcemaps = _interopDefault(require('rollup-plugin-sourcemaps'));
var rollupPluginCommonjs = _interopDefault(require('rollup-plugin-commonjs'));
var gulpRename = _interopDefault(require('gulp-rename'));

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var ITransform = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransform = void 0;


/**
 *check target is transform or not.
 *
 * @export
 * @param {*} target
 * @returns {boolean}
 */
function isTransform(target) {
    return (ioc.isObject(target) === true) && (target instanceof stream.Stream || (ioc.isFunction(target.pipe) && !ioc.isObservable(target)));
}
exports.isTransform = isTransform;


});

unwrapExports(ITransform);
var ITransform_1 = ITransform.isTransform;

var IPlatformService = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformServiceToken = void 0;

exports.PlatformServiceToken = ioc.tokenId('pack_PlatformService');


});

unwrapExports(IPlatformService);
var IPlatformService_1 = IPlatformService.PlatformServiceToken;

var NodeActivityContext_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeActivityContext = void 0;





/**
 * pipe activity context.
 *
 * @export
 * @class NodeActivityContext
 * @extends {ActivityContext}
 * @implements {IActivityContext<ITransform>}
 */
var NodeActivityContext = /** @class */ (function (_super) {
    tslib.__extends(NodeActivityContext, _super);
    function NodeActivityContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeActivityContext_1 = NodeActivityContext;
    Object.defineProperty(NodeActivityContext.prototype, "platform", {
        get: function () {
            var _a;
            return (_a = this.context.getValue(IPlatformService.PlatformServiceToken)) !== null && _a !== void 0 ? _a : this.getPlatform();
        },
        enumerable: false,
        configurable: true
    });
    NodeActivityContext.prototype.getPlatform = function () {
        var pf = this.injector.getInstance(IPlatformService.PlatformServiceToken, { provide: NodeActivityContext_1, useValue: this });
        pf && this.setValue(IPlatformService.PlatformServiceToken, pf);
        return pf;
    };
    NodeActivityContext.ρAnn = function () {
        return { "name": "NodeActivityContext", "params": {} };
    };
    var NodeActivityContext_1;
    NodeActivityContext = NodeActivityContext_1 = tslib.__decorate([
        ioc.Injectable,
        ioc.Refs(activities.Activity, boot.BuildContext)
    ], NodeActivityContext);
    return NodeActivityContext;
}(activities.ActivityContext));
exports.NodeActivityContext = NodeActivityContext;


});

unwrapExports(NodeActivityContext_1);
var NodeActivityContext_2 = NodeActivityContext_1.NodeActivityContext;

var PlatformService_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformService = void 0;











var relChkExp = /^(.{1,2}\/?\\?)?$/;
var notExp = /^!/;
var replNodeMdlExp = /(node_modules)[\\\/]/g;
var PlatformService = /** @class */ (function () {
    function PlatformService(ctx) {
        this.ctx = ctx;
        this.packageFile = 'package.json';
    }
    /**
     * get evn args.
     *
     * @returns {ObjectMap}
     * @memberof NodeContext
     */
    PlatformService.prototype.getEnvArgs = function () {
        if (!this.envArgs) {
            this.envArgs = minimist(tslib.__spreadArrays(this.ctx.workflow.args, process.argv.slice(2)));
        }
        return this.envArgs;
    };
    PlatformService.prototype.hasArg = function (arg) {
        return process.argv.indexOf(arg) > -1 || process.argv.indexOf('--' + arg) > -1;
    };
    /**
     * get root folders.
     *
     * @param {Express2<string, string, boolean>} [express]
     * @returns {string[]}
     * @memberof NodeContext
     */
    PlatformService.prototype.getRootFolders = function (express) {
        return this.getFolders(this.getRootPath(), express);
    };
    PlatformService.prototype.getCompilerOptions = function (tsconfig) {
        var filename = this.toRootPath(tsconfig);
        var cfg = platformServer.syncRequire(filename) || {};
        return cfg.compilerOptions || {};
    };
    PlatformService.prototype.getFileName = function (pathName) {
        return path.basename(pathName).replace(path.extname(pathName), '');
    };
    /**
     * get folders of path.
     *
     * @param {string} pathstr
     * @param {Express2<string, string, boolean>} [express]
     * @returns {string[]}
     * @memberof NodeContext
     */
    PlatformService.prototype.getFolders = function (pathstr, express) {
        pathstr = path.normalize(pathstr);
        var dir = fs.readdirSync(pathstr);
        var folders = [];
        dir.forEach(function (d) {
            var sf = path.join(pathstr, d);
            var f = fs.lstatSync(sf);
            if (f.isDirectory()) {
                if (express) {
                    var fl = express(sf, d);
                    if (fl) {
                        folders.push(fl);
                    }
                }
                else {
                    folders.push(sf);
                }
            }
        });
        return folders;
    };
    PlatformService.prototype.getFiles = function (express, options, filter, mapping) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var filePaths;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(ioc.isString(express) || ioc.isArray(express))) {
                            throw Error('input express param type error!');
                        }
                        if (ioc.isFunction(options)) {
                            filter = options;
                            mapping = filter;
                            options = {};
                        }
                        return [4 /*yield*/, globby(this.normalizeSrc(express), options)];
                    case 1:
                        filePaths = (_a.sent()).map(function (e) { return ioc.isString(e) ? e : e.path; });
                        if (filter) {
                            filePaths = filePaths.filter(filter);
                        }
                        if (mapping) {
                            return [2 /*return*/, filePaths.map(mapping)];
                        }
                        return [2 /*return*/, filePaths];
                }
            });
        });
    };
    PlatformService.prototype.join = function () {
        var paths = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            paths[_i] = arguments[_i];
        }
        return path.join.apply(void 0, paths);
    };
    PlatformService.prototype.normalize = function (url) {
        return url ? url.split('\\').join('/') : url;
    };
    PlatformService.prototype.normalizeSrc = function (src) {
        var _this = this;
        if (ioc.isString(src)) {
            return this.normalize(src);
        }
        else {
            return src.map(function (s) { return _this.normalize(s); });
        }
    };
    PlatformService.prototype.copyFile = function (src, dist, options) {
        if (options && options.force) {
            shelljs.rm('-f', dist);
            shelljs.cp(src, dist);
        }
        else {
            shelljs.cp(src, dist);
        }
    };
    PlatformService.prototype.existsFile = function (filename) {
        return fs.existsSync(this.toRootPath(filename));
    };
    PlatformService.prototype.copyDir = function (src, dist, options) {
        if (!fs.existsSync(dist)) {
            shelljs.mkdir('-p', dist);
        }
        if (options && options.force) {
            shelljs.rm('-rf', path.normalize(path.join(dist, '/')));
            shelljs.mkdir('-p', path.normalize(path.join(dist, '/')));
            shelljs.cp('-R', path.normalize(src + '/*'), path.normalize(path.join(dist, '/')));
        }
        else {
            shelljs.cp('-R', path.normalize(src + '/*'), path.normalize(path.join(dist, '/')));
        }
    };
    PlatformService.prototype.copyTo = function (filePath, dist) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var outFile;
            return tslib.__generator(this, function (_a) {
                outFile = path.join(dist, filePath.replace(replNodeMdlExp, ''));
                return [2 /*return*/, new Promise(function (res) {
                        if (!fs.existsSync(outFile)) {
                            if (!fs.existsSync(path.dirname(outFile))) {
                                shelljs.mkdir('-p', path.dirname(outFile));
                            }
                            shelljs.cp('-R', path.join(filePath), outFile);
                            res(true);
                        }
                    })];
            });
        });
    };
    PlatformService.prototype.del = function (src, opts) {
        return del(this.normalizeSrc(src), opts);
    };
    /**
     * to root path.
     *
     * @param {string} pathstr
     * @returns {string}
     * @memberof NodeContext
     */
    PlatformService.prototype.toRootPath = function (pathstr) {
        var root = this.getRootPath();
        return root ? platformServer.toAbsolutePath(root, pathstr) : this.normalize(pathstr);
    };
    /**
     * convert path to relative root path.
     *
     * @param {string} pathstr
     * @returns {string}
     * @memberof NodeActivityContext
     */
    PlatformService.prototype.relativeRoot = function (pathstr) {
        if (relChkExp.test(pathstr)) {
            return pathstr;
        }
        var fullpath = this.toRootPath(pathstr);
        return path.relative(this.getRootPath(), fullpath) || '.';
    };
    PlatformService.prototype.getRootPath = function () {
        return this.ctx.baseURL;
    };
    PlatformService.prototype.toRootSrc = function (src) {
        var _this = this;
        var root = this.getRootPath();
        if (root) {
            if (ioc.isString(src)) {
                return this.prefixSrc(root, src);
            }
            else {
                return src.map(function (s) { return _this.prefixSrc(root, s); });
            }
        }
        return src;
    };
    PlatformService.prototype.relativePath = function (path1, path2) {
        return path.relative(path1, path2);
    };
    PlatformService.prototype.prefixSrc = function (root, strSrc) {
        var prefix = '';
        if (notExp.test(strSrc)) {
            prefix = '!';
            strSrc = strSrc.substring(1, strSrc.length);
        }
        return prefix + platformServer.toAbsolutePath(root, strSrc);
    };
    /**
     * get package.
     *
     * @returns {*}
     * @memberof NodeContext
     */
    PlatformService.prototype.getPackage = function () {
        if (!this._package) {
            var filename = this.toRootPath(this.packageFile);
            this._package = platformServer.syncRequire(filename);
        }
        return this._package;
    };
    /**
     * get package version.
     *
     * @returns {string}
     * @memberof NodeContext
     */
    PlatformService.prototype.getPackageVersion = function () {
        var packageCfg = this.getPackage();
        if (!packageCfg) {
            return '';
        }
        return packageCfg.version || '';
    };
    /**
     * get module version.
     *
     * @param {string} name
     * @param {boolean} [dependencies=false]
     * @returns {string}
     * @memberof NodeContext
     */
    PlatformService.prototype.getModuleVersion = function (name, dependencies) {
        if (dependencies === void 0) { dependencies = false; }
        var packageCfg = this.getPackage();
        if (!packageCfg) {
            return '';
        }
        var version = '';
        if (packageCfg.dependencies) {
            version = packageCfg.dependencies[name];
        }
        if (!dependencies && !version && packageCfg.devDependencies) {
            version = packageCfg.devDependencies[name];
        }
        return version || '';
    };
    PlatformService.ρAnn = function () {
        return { "name": "PlatformService", "params": { "constructor": ["ctx"], "hasArg": ["arg"], "getRootFolders": ["express"], "getCompilerOptions": ["tsconfig"], "getFileName": ["pathName"], "getFolders": ["pathstr", "express"], "getFiles": ["express", "options", "filter", "mapping"], "join": ["paths"], "normalize": ["url"], "normalizeSrc": ["src"], "copyFile": ["src", "dist", "options"], "existsFile": ["filename"], "copyDir": ["src", "dist", "options"], "copyTo": ["filePath", "dist"], "del": ["src", "opts"], "toRootPath": ["pathstr"], "relativeRoot": ["pathstr"], "toRootSrc": ["src"], "relativePath": ["path1", "path2"], "prefixSrc": ["root", "strSrc"], "getModuleVersion": ["name", "dependencies"] } };
    };
    PlatformService = tslib.__decorate([
        ioc.Injectable(IPlatformService.PlatformServiceToken),
        tslib.__metadata("design:paramtypes", [NodeActivityContext_1.NodeActivityContext])
    ], PlatformService);
    return PlatformService;
}());
exports.PlatformService = PlatformService;


});

unwrapExports(PlatformService_1);
var PlatformService_2 = PlatformService_1.PlatformService;

var NodeActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeActivity = void 0;


/**
 * activity for server side.
 *
 * @export
 * @abstract
 * @class NodeActivity
 * @extends {Activity<T>}
 * @template T
 */
var NodeActivity = /** @class */ (function (_super) {
    tslib.__extends(NodeActivity, _super);
    function NodeActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeActivity.ρAnn = function () {
        return { "name": "NodeActivity" };
    };
    return NodeActivity;
}(activities.Activity));
exports.NodeActivity = NodeActivity;


});

unwrapExports(NodeActivity_1);
var NodeActivity_2 = NodeActivity_1.NodeActivity;

var CleanActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.CleanActivity = void 0;




/**
 * Source activity.
 *
 * @export
 * @class CleanActivity
 * @extends {Activity}
 */
var CleanActivity = /** @class */ (function (_super) {
    tslib.__extends(CleanActivity, _super);
    function CleanActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CleanActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var clean;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.clean)];
                    case 1:
                        clean = _a.sent();
                        if (!clean) return [3 /*break*/, 3];
                        return [4 /*yield*/, ctx.platform.del(ctx.platform.normalizeSrc(clean), { force: true, cwd: ctx.platform.getRootPath() })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CleanActivity.ρAnn = function () {
        return { "name": "CleanActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], CleanActivity.prototype, "clean", void 0);
    CleanActivity = tslib.__decorate([
        activities.Task('clean, [clean]')
    ], CleanActivity);
    return CleanActivity;
}(NodeActivity_1.NodeActivity));
exports.CleanActivity = CleanActivity;


});

unwrapExports(CleanActivity_1);
var CleanActivity_2 = CleanActivity_1.CleanActivity;

var ServeActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServeActivity = void 0;




/**
 * Serve activity.
 *
 * @export
 * @class ServeActivity
 * @extends {BuildActivity}
 */
var ServeActivity = /** @class */ (function (_super) {
    tslib.__extends(ServeActivity, _super);
    function ServeActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * before run sequence.
     *
     * @protected
     * @returns {Promise<void>}
     * @memberof ServeActivity
     */
    ServeActivity.prototype.execute = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    ServeActivity.ρAnn = function () {
        return { "name": "ServeActivity", "params": {} };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Number)
    ], ServeActivity.prototype, "port", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], ServeActivity.prototype, "dirs", void 0);
    ServeActivity = tslib.__decorate([
        activities.Task('serve')
    ], ServeActivity);
    return ServeActivity;
}(NodeActivity_1.NodeActivity));
exports.ServeActivity = ServeActivity;


});

unwrapExports(ServeActivity_1);
var ServeActivity_2 = ServeActivity_1.ServeActivity;

var ShellActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellActivity = void 0;






var preWordExp = /^[a-zA-Z]/;
/**
 * Shell Task
 *
 * @class ShellActivity
 * @implements {ITask}
 */
var ShellActivity = /** @class */ (function (_super) {
    tslib.__extends(ShellActivity, _super);
    function ShellActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShellActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var shell, options, args, argstrs, allowError, shells;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.shell)];
                    case 1:
                        shell = _a.sent();
                        return [4 /*yield*/, ctx.resolveExpression(this.options)];
                    case 2:
                        options = _a.sent();
                        return [4 /*yield*/, ctx.resolveExpression(this.args)];
                    case 3:
                        args = _a.sent();
                        argstrs = ioc.isArray(args) ? args : this.formatArgs(args);
                        return [4 /*yield*/, ctx.resolveExpression(this.allowError)];
                    case 4:
                        allowError = _a.sent();
                        shells = ioc.isArray(shell) ? shell : [shell];
                        if (!this.parallel) return [3 /*break*/, 6];
                        return [4 /*yield*/, Promise.all(shells.map(function (sh) { return _this.execShell(sh, argstrs, options, allowError); }))];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, ioc.PromiseUtil.step(shells.map(function (sh) { return function () { return _this.execShell(sh, argstrs, options, allowError); }; }))];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ShellActivity.prototype.formatShell = function (shell, args) {
        if (args.length) {
            return shell + ' ' + args.join(' ');
        }
        return shell;
    };
    ShellActivity.prototype.formatArgs = function (args) {
        var _this = this;
        var strArgs = [];
        ioc.lang.forIn(args, function (val, k) {
            if (k === 'root' || !preWordExp.test(k)) {
                return;
            }
            if (ioc.isArray(val)) {
                strArgs.push("--" + k + " " + val.join(','));
            }
            else if (!ioc.isNullOrUndefined(val)) {
                var arg = _this.formatArg(val, k, args);
                if (arg) {
                    strArgs.push(arg);
                }
            }
        });
        return strArgs;
    };
    ShellActivity.prototype.formatArg = function (arg, key, args) {
        if (ioc.isBoolean(arg) && arg) {
            return "--" + key;
        }
        if (!ioc.isNullOrUndefined(arg)) {
            return "--" + key + " " + arg;
        }
        return '';
    };
    ShellActivity.prototype.execShell = function (cmd, args, options, allowError) {
        var _this = this;
        cmd = this.formatShell(cmd, args);
        if (!cmd) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            var shell = child_process.exec(cmd, options, function (err, stdout, stderr) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(stdout);
                }
            });
            shell.stdout.on('data', function (data) {
                _this.checkStdout(data, resolve, reject);
            });
            shell.stderr.on('data', function (err) {
                _this.checkStderr(err, reject, allowError);
            });
            shell.on('exit', function (code) {
                var msg = "exit child process with code\uFF1A" + code + " ";
                console.log(msg);
                if (code > 0) {
                    reject(new Error(msg));
                }
            });
        });
    };
    ShellActivity.prototype.checkStderr = function (err, reject, allowError) {
        console.error(err);
        if (allowError === false) {
            reject(err);
        }
    };
    ShellActivity.prototype.checkStdout = function (data, resolve, reject) {
        console.log(data);
    };
    ShellActivity.ρAnn = function () {
        return { "name": "ShellActivity", "params": { "execute": ["ctx"], "formatShell": ["shell", "args"], "formatArgs": ["args"], "formatArg": ["arg", "key", "args"], "execShell": ["cmd", "args", "options", "allowError"], "checkStderr": ["err", "reject", "allowError"], "checkStdout": ["data", "resolve", "reject"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], ShellActivity.prototype, "shell", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], ShellActivity.prototype, "args", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], ShellActivity.prototype, "options", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], ShellActivity.prototype, "allowError", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Boolean)
    ], ShellActivity.prototype, "parallel", void 0);
    ShellActivity = tslib.__decorate([
        activities.Task('shell')
    ], ShellActivity);
    return ShellActivity;
}(NodeActivity_1.NodeActivity));
exports.ShellActivity = ShellActivity;


});

unwrapExports(ShellActivity_1);
var ShellActivity_2 = ShellActivity_1.ShellActivity;

var UnitTestActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitTestActivity = void 0;






var UnitTestActivity = /** @class */ (function (_super) {
    tslib.__extends(UnitTestActivity, _super);
    function UnitTestActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnitTestActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var test, options;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.test)];
                    case 1:
                        test = _a.sent();
                        return [4 /*yield*/, ctx.resolveExpression(this.options)];
                    case 2:
                        options = _a.sent();
                        if (!test) return [3 /*break*/, 4];
                        return [4 /*yield*/, unit.runTest(test, tslib.__assign({ baseURL: ctx.platform.getRootPath() }, options), unitConsole.ConsoleReporter)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UnitTestActivity.ρAnn = function () {
        return { "name": "UnitTestActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], UnitTestActivity.prototype, "test", void 0);
    tslib.__decorate([
        components.Input('testOptions'),
        tslib.__metadata("design:type", Object)
    ], UnitTestActivity.prototype, "options", void 0);
    UnitTestActivity = tslib.__decorate([
        activities.Task('test, [test]')
    ], UnitTestActivity);
    return UnitTestActivity;
}(NodeActivity_1.NodeActivity));
exports.UnitTestActivity = UnitTestActivity;


});

unwrapExports(UnitTestActivity_1);
var UnitTestActivity_2 = UnitTestActivity_1.UnitTestActivity;

var WatchActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchActivity = void 0;








/**
 * watch activity.
 *
 * @export
 * @class WatchActivity
 * @extends {BuildHandleActivity}
 */
var WatchActivity = /** @class */ (function (_super) {
    tslib.__extends(WatchActivity, _super);
    function WatchActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WatchActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var watchSrc, options, watcher, defer;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                watchSrc = this.watch;
                options = this.options;
                watcher = chokidar.watch(ctx.platform.normalizeSrc(watchSrc), Object.assign({ ignored: /[\/\\]\./, ignoreInitial: true, cwd: ctx.platform.getRootPath() }, options));
                defer = ioc.PromiseUtil.defer();
                rxjs.fromEventPattern(function (handler) {
                    watcher.on('add', function (paths) { return handler(paths); });
                    watcher.on('change', function (paths) { return handler(paths); });
                    watcher.on('unlink', function (paths) { return handler(paths); });
                    watcher.on('unlinkDir', function (paths) { return handler(paths); });
                }, function (handler) {
                    watcher.close();
                })
                    .pipe(operators.bufferTime(300), operators.filter(function (c) { return c.length > 0; }))
                    .subscribe(function (chg) {
                    ctx.getExector().runActivity(_this.body);
                });
                defer.promise;
                return [2 /*return*/];
            });
        });
    };
    WatchActivity.ρAnn = function () {
        return { "name": "WatchActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], WatchActivity.prototype, "watch", void 0);
    tslib.__decorate([
        components.Input('watchOptions'),
        tslib.__metadata("design:type", Object)
    ], WatchActivity.prototype, "options", void 0);
    tslib.__decorate([
        components.Input({ bindingType: 'dynamic' }),
        tslib.__metadata("design:type", Object)
    ], WatchActivity.prototype, "body", void 0);
    WatchActivity = tslib.__decorate([
        activities.Task('watch')
    ], WatchActivity);
    return WatchActivity;
}(NodeActivity_1.NodeActivity));
exports.WatchActivity = WatchActivity;


});

unwrapExports(WatchActivity_1);
var WatchActivity_2 = WatchActivity_1.WatchActivity;

var tasks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib.__exportStar(CleanActivity_1, exports);
tslib.__exportStar(ServeActivity_1, exports);
tslib.__exportStar(ShellActivity_1, exports);
tslib.__exportStar(UnitTestActivity_1, exports);
tslib.__exportStar(WatchActivity_1, exports);


});

unwrapExports(tasks);

var RollupActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupActivity = void 0;






/**
 * rollup activity.
 *
 * @export
 * @class RollupActivity
 * @extends {NodeActivity<void>}
 */
var RollupActivity = /** @class */ (function (_super) {
    tslib.__extends(RollupActivity, _super);
    function RollupActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RollupActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var opts;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.options)];
                    case 1:
                        opts = _a.sent();
                        opts = opts || { input: '' };
                        return [4 /*yield*/, Promise.all(this.getInputProps()
                                .map(function (n) { return tslib.__awaiter(_this, void 0, void 0, function () {
                                var val;
                                return tslib.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, ctx.resolveExpression(this[n])];
                                        case 1:
                                            val = _a.sent();
                                            this.setOptions(ctx, opts, n, val);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all((ioc.isArray(opts.output) ? opts.output : [opts.output]).map(function (output) { return tslib.__awaiter(_this, void 0, void 0, function () {
                                var sourceMap, globals, bundle;
                                return tslib.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.sourcemap) return [3 /*break*/, 2];
                                            return [4 /*yield*/, ctx.resolveExpression(this.sourcemap)];
                                        case 1:
                                            sourceMap = _a.sent();
                                            if (sourceMap) {
                                                output.sourcemap = ioc.isString(sourceMap) ? true : sourceMap;
                                            }
                                            _a.label = 2;
                                        case 2:
                                            if (!this.globals) return [3 /*break*/, 4];
                                            return [4 /*yield*/, ctx.resolveExpression(this.globals)];
                                        case 3:
                                            globals = _a.sent();
                                            output.globals = globals;
                                            return [3 /*break*/, 5];
                                        case 4:
                                            output.globals = {};
                                            _a.label = 5;
                                        case 5:
                                            if (ioc.isArray(opts.external) && opts.external.length) {
                                                opts.external = this.vailfExternal(opts.external);
                                                opts.external.forEach(function (k) {
                                                    if (output.globals[k]) {
                                                        output.globals[k] = k;
                                                    }
                                                });
                                            }
                                            if (output.file) {
                                                output.file = ctx.platform.toRootPath(output.file);
                                            }
                                            if (output.dir) {
                                                output.dir = ctx.platform.toRootPath(output.dir);
                                            }
                                            if (!output.name && output.file) {
                                                output.name = ctx.platform.getFileName(output.file);
                                            }
                                            return [4 /*yield*/, this.resolvePlugins(ctx, opts)];
                                        case 6:
                                            _a.sent();
                                            if (opts.plugins) {
                                                opts.plugins = opts.plugins.filter(function (p) { return p; });
                                            }
                                            return [4 /*yield*/, rollup.rollup(opts)];
                                        case 7:
                                            bundle = _a.sent();
                                            return [4 /*yield*/, bundle.write(output)];
                                        case 8:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })).catch(function (err) {
                                console.error(err);
                                throw err;
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RollupActivity.prototype.getInputProps = function () {
        return ['input', 'output', 'plugins', 'external', 'cache', 'watch'];
    };
    RollupActivity.prototype.setOptions = function (ctx, opts, key, val) {
        if (key === 'input') {
            val = ctx.platform.toRootSrc(val);
        }
        if (ioc.isArray(val) && val.length) {
            val = val.filter(function (f) { return !ioc.isNullOrUndefined(f); });
            if (val.length) {
                opts[key] = val;
            }
        }
        else if (val) {
            opts[key] = val;
        }
    };
    RollupActivity.prototype.vailfExternal = function (external) {
        return external || [];
    };
    RollupActivity.prototype.resolvePlugins = function (ctx, opts) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    RollupActivity.ρAnn = function () {
        return { "name": "RollupActivity", "params": { "execute": ["ctx"], "setOptions": ["ctx", "opts", "key", "val"], "vailfExternal": ["external"], "resolvePlugins": ["ctx", "opts"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "input", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "output", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "plugins", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "external", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "globals", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "sourcemap", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "cache", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "options", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupActivity.prototype, "watch", void 0);
    RollupActivity = tslib.__decorate([
        activities.Task('rollup')
    ], RollupActivity);
    return RollupActivity;
}(NodeActivity_1.NodeActivity));
exports.RollupActivity = RollupActivity;


});

unwrapExports(RollupActivity_1);
var RollupActivity_2 = RollupActivity_1.RollupActivity;

var exps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsFileExp = exports.tsFileExp = exports.esmChkExp = exports.mapexp = exports.tsdexp = void 0;
exports.tsdexp = /.d.ts$/;
exports.mapexp = /.map$/;
exports.esmChkExp = /^esm/;
exports.tsFileExp = /.ts$/;
exports.jsFileExp = /.js$/;


});

unwrapExports(exps);
var exps_1 = exps.jsFileExp;
var exps_2 = exps.tsFileExp;
var exps_3 = exps.esmChkExp;
var exps_4 = exps.mapexp;
var exps_5 = exps.tsdexp;

var tsComplie = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsComplie = void 0;






var TsComplie = /** @class */ (function () {
    function TsComplie() {
    }
    TsComplie.prototype.compile = function (options, fileName, sourceText, annotation) {
        var host = typescript.createCompilerHost(options);
        var outputs = new Map();
        console.log(fileName);
        var tempSourceFile = typescript.createSourceFile(fileName, annotation ? annotations.iocAnnotations(sourceText) : sourceText, typescript.ScriptTarget.Latest, false, typescript.ScriptKind.TS);
        host.getSourceFile = function (name, languageVersion, error) {
            if (name === fileName) {
                return tempSourceFile;
            }
        };
        host.writeFile = function (fileName, contents) { return outputs.set(fileName, contents); };
        var old = this.program;
        var program = this.program = typescript.createProgram([fileName], options, host, old);
        var emitResult = program.emit();
        var allDiagnostics = program.getSyntacticDiagnostics(tempSourceFile).concat(emitResult.diagnostics);
        if (!this.validateDiagnostics(allDiagnostics, true)) {
            return {
                code: null,
                map: null,
                emitSkipped: true,
            };
        }
        var emitSkipped = emitResult.emitSkipped;
        var code, map = null, dts;
        outputs.forEach(function (source, f) {
            if (exps.tsdexp.test(f)) {
                dts = source;
            }
            else if (exps.jsFileExp.test(f)) {
                code = source;
            }
            else if (exps.mapexp.test(f)) {
                map = source;
            }
        });
        outputs.clear();
        return { code: code, map: map, dts: dts, emitSkipped: emitSkipped };
    };
    TsComplie.prototype.transpileModule = function (compilerOptions, fileName, code, annotation) {
        var transformed = typescript.transpileModule(annotation ? annotations.iocAnnotations(code) : code, {
            fileName: fileName,
            reportDiagnostics: true,
            compilerOptions: compilerOptions,
            transformers: {
                afterDeclarations: []
            }
        });
        // All errors except `Cannot compile modules into 'es6' when targeting 'ES5' or lower.`
        var diagnostics = transformed.diagnostics ?
            transformed.diagnostics.filter(function (diagnostic) { return diagnostic.code !== 1204; }) : [];
        if (!this.validateDiagnostics(diagnostics, true)) {
            throw new Error("There were TypeScript errors transpiling");
        }
        return {
            code: transformed.outputText,
            // Rollup expects `map` to be an object so we must parse the string
            map: transformed.sourceMapText ? JSON.parse(transformed.sourceMapText) : null
        };
    };
    TsComplie.prototype.parseTsconfig = function (projectDirectory, tsconfig, settings) {
        var compilerOptions;
        // let projectReferences: ReadonlyArray<ProjectReference>;
        var settingsResult = typescript.convertCompilerOptionsFromJson(settings || {}, projectDirectory);
        // if (settingsResult.errors) {
        //     throw settingsResult.errors;
        // }
        compilerOptions = settingsResult.options;
        var tsConfig = typescript.readConfigFile(tsconfig, typescript.sys.readFile);
        if (tsConfig.error) {
            console.log(tsConfig.error.messageText);
        }
        var parsed = typescript.parseJsonConfigFileContent(tsConfig.config || {}, this.getTsconfigSystem(typescript.sys), path.resolve(projectDirectory), compilerOptions, tsconfig);
        this.validateDiagnostics(parsed.errors);
        return parsed;
    };
    TsComplie.prototype.getTsconfigSystem = function (sys) {
        return {
            useCaseSensitiveFileNames: sys.useCaseSensitiveFileNames,
            readDirectory: function () { return []; },
            fileExists: sys.fileExists,
            readFile: sys.readFile
        };
    };
    TsComplie.prototype.validateDiagnostics = function (diagnostics, strict) {
        // Print error diagnostics.
        var hasError = diagnostics.some(function (diag) { return diag.category === typescript.DiagnosticCategory.Error; });
        if (hasError) {
            // Throw only if we're in strict mode, otherwise return original content.
            if (strict) {
                var errorMessages = typescript.formatDiagnostics(diagnostics, {
                    getCurrentDirectory: function () { return typescript.sys.getCurrentDirectory(); },
                    getNewLine: function () { return typescript.sys.newLine; },
                    getCanonicalFileName: function (f) { return f; },
                });
                throw new Error("\n              TS failed with the following error messages:\n              " + errorMessages + "\n            ");
            }
            else {
                return false;
            }
        }
        return true;
    };
    TsComplie.ρAnn = function () {
        return { "name": "TsComplie", "params": { "compile": ["options", "fileName", "sourceText", "annotation"], "transpileModule": ["compilerOptions", "fileName", "code", "annotation"], "parseTsconfig": ["projectDirectory", "tsconfig", "settings"], "getTsconfigSystem": ["sys"], "validateDiagnostics": ["diagnostics", "strict"] } };
    };
    TsComplie = tslib.__decorate([
        ioc.Injectable()
    ], TsComplie);
    return TsComplie;
}());
exports.TsComplie = TsComplie;


});

unwrapExports(tsComplie);
var tsComplie_1 = tsComplie.TsComplie;

var RollupTsActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupTsActivity = void 0;










var TSLIB_ID = '\0tslib';
var RollupTsActivity = /** @class */ (function (_super) {
    tslib.__extends(RollupTsActivity, _super);
    function RollupTsActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RollupTsActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.exeCache = {};
                        return [4 /*yield*/, _super.prototype.execute.call(this, ctx)];
                    case 1:
                        _a.sent();
                        delete this.exeCache;
                        return [2 /*return*/];
                }
            });
        });
    };
    RollupTsActivity.prototype.getInputProps = function () {
        return tslib.__spreadArrays(_super.prototype.getInputProps.call(this), ['beforeCompile', 'afterCompile']);
    };
    RollupTsActivity.prototype.vailfExternal = function (external) {
        var _this = this;
        if (this.includeLib && this.includeLib.length) {
            return (external || []).filter(function (ex) { return _this.includeLib.indexOf(ex) < 0; });
        }
        return _super.prototype.vailfExternal.call(this, external);
    };
    RollupTsActivity.prototype.setOptions = function (ctx, opts, key, val) {
        if (key === 'beforeCompile') {
            this.exeCache.beforeCompile = val;
        }
        else if (key === 'afterCompile') {
            this.exeCache.afterCompile = val;
        }
        else {
            _super.prototype.setOptions.call(this, ctx, opts, key, val);
        }
    };
    RollupTsActivity.prototype.resolvePlugins = function (ctx, opts) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var plugins, _a, beforeCompile, afterCompile, compile, _b, _c, ugfy, uglify;
            return tslib.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        plugins = [];
                        _a = this.exeCache, beforeCompile = _a.beforeCompile, afterCompile = _a.afterCompile;
                        if (beforeCompile && beforeCompile.length) {
                            plugins.push.apply(plugins, beforeCompile);
                        }
                        if (!this.tscompile) return [3 /*break*/, 2];
                        return [4 /*yield*/, ctx.resolveExpression(this.tscompile)];
                    case 1:
                        compile = _d.sent();
                        plugins.push(compile);
                        return [3 /*break*/, 4];
                    case 2:
                        _c = (_b = plugins).push;
                        return [4 /*yield*/, this.getDefaultTsCompiler(ctx)];
                    case 3:
                        _c.apply(_b, [_d.sent()]);
                        _d.label = 4;
                    case 4:
                        if (opts.plugins && opts.plugins.length) {
                            plugins.push.apply(plugins, opts.plugins);
                        }
                        if (afterCompile && afterCompile.length) {
                            plugins.push.apply(plugins, afterCompile);
                        }
                        if (!this.uglify) return [3 /*break*/, 6];
                        return [4 /*yield*/, ctx.resolveExpression(this.uglify)];
                    case 5:
                        ugfy = _d.sent();
                        uglify = platformServer.syncRequire('rollup-plugin-uglify');
                        if (ioc.isBoolean(ugfy)) {
                            ugfy && plugins.push(uglify());
                        }
                        else {
                            plugins.push(ugfy);
                        }
                        _d.label = 6;
                    case 6:
                        opts.plugins = plugins;
                        return [2 /*return*/];
                }
            });
        });
    };
    RollupTsActivity.prototype.getDefaultTsCompiler = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var tslib$1, include, exclude, annotation, filter, compile, projectDirectory, settings, tsconfig, parsed, allImportedFiles;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tslib$1 = platformServer.syncRequire('tslib');
                        return [4 /*yield*/, ctx.resolveExpression(this.include)];
                    case 1:
                        include = _a.sent();
                        return [4 /*yield*/, ctx.resolveExpression(this.exclude)];
                    case 2:
                        exclude = _a.sent();
                        return [4 /*yield*/, ctx.resolveExpression(this.annotation)];
                    case 3:
                        annotation = _a.sent();
                        filter = rollupPluginutils.createFilter(include, exclude);
                        compile = ctx.injector.get(tsComplie.TsComplie);
                        projectDirectory = ctx.platform.getRootPath();
                        return [4 /*yield*/, ctx.resolveExpression(this.compileOptions)];
                    case 4:
                        settings = _a.sent();
                        return [4 /*yield*/, ctx.resolveExpression(this.tsconfig)];
                    case 5:
                        tsconfig = _a.sent();
                        tsconfig = ctx.platform.toRootPath(tsconfig);
                        parsed = compile.parseTsconfig(projectDirectory, tsconfig, settings);
                        allImportedFiles = new Set();
                        return [2 /*return*/, {
                                name: 'typescript',
                                resolveId: function (importee, importer) {
                                    if (importee === 'tslib') {
                                        return TSLIB_ID;
                                    }
                                    if (!importer) {
                                        return null;
                                    }
                                    importer = ctx.platform.normalize(importer);
                                    if (!allImportedFiles.has(importer)) {
                                        return;
                                    }
                                    var result = typescript.nodeModuleNameResolver(importee, importer, parsed.options, typescript.sys);
                                    if (result.resolvedModule && result.resolvedModule.resolvedFileName) {
                                        if (exps.tsdexp.test(result.resolvedModule.resolvedFileName || '')) {
                                            return null;
                                        }
                                        return result.resolvedModule.resolvedFileName;
                                    }
                                    return null;
                                },
                                load: function (id) {
                                    if (id === TSLIB_ID) {
                                        return tslib$1;
                                    }
                                },
                                transform: function (code, id) {
                                    if (!filter(id)) {
                                        return undefined;
                                    }
                                    allImportedFiles.add(id.split('\\').join('/'));
                                    return compile.transpileModule(parsed.options, id, code, annotation);
                                }
                            }];
                }
            });
        });
    };
    RollupTsActivity.ρAnn = function () {
        return { "name": "RollupTsActivity", "params": { "execute": ["ctx"], "vailfExternal": ["external"], "setOptions": ["ctx", "opts", "key", "val"], "resolvePlugins": ["ctx", "opts"], "getDefaultTsCompiler": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input('beforeCompilePlugins'),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "beforeCompile", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "tscompile", void 0);
    tslib.__decorate([
        components.Input('afterCompilePlugins'),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "afterCompile", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], RollupTsActivity.prototype, "includeLib", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "annotation", void 0);
    tslib.__decorate([
        components.Input('include', ['*.ts+(|x)', '**/*.ts+(|x)']),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "include", void 0);
    tslib.__decorate([
        components.Input('exclude', ['*.d.ts', '**/*.d.ts']),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "exclude", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "dts", void 0);
    tslib.__decorate([
        components.Input('tsconfig', './tsconfig.json'),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "tsconfig", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "compileOptions", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], RollupTsActivity.prototype, "uglify", void 0);
    RollupTsActivity = tslib.__decorate([
        activities.Task({
            selector: 'rts'
        })
    ], RollupTsActivity);
    return RollupTsActivity;
}(RollupActivity_1.RollupActivity));
exports.RollupTsActivity = RollupTsActivity;


});

unwrapExports(RollupTsActivity_1);
var RollupTsActivity_2 = RollupTsActivity_1.RollupTsActivity;

var rollups = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib.__exportStar(RollupActivity_1, exports);
tslib.__exportStar(RollupTsActivity_1, exports);


});

unwrapExports(rollups);

var TransformActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformActivity = void 0;




/**
 * transform activity.
 *
 * @export
 * @abstract
 * @class TransfrmActivity
 * @extends {NodeActivity<ITransform>}
 */
var TransformActivity = /** @class */ (function (_super) {
    tslib.__extends(TransformActivity, _super);
    function TransformActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * execute stream pipe.
     *
     * @protected
     * @param {NodeActivityContext} ctx
     * @param {ITransform} stream stream pipe from
     * @param {GActivityType<ITransform>} transform steam pipe to.
     * @param {boolean} [waitend=false] wait pipe end or not.
     * @returns {Promise<ITransform>}
     * @memberof TransformActivity
     */
    TransformActivity.prototype.pipeStream = function (ctx, stream, transform, waitend) {
        if (waitend === void 0) { waitend = false; }
        return tslib.__awaiter(this, void 0, void 0, function () {
            var transPipe, next, defer;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ITransform.isTransform(transform)) return [3 /*break*/, 1];
                        transPipe = transform;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, ctx.resolveExpression(transform)];
                    case 2:
                        transPipe = _a.sent();
                        _a.label = 3;
                    case 3:
                        next = stream.pipe(transPipe);
                        next.once('error', function (err) {
                            console.error(err);
                            if (ioc.isDefined(process)) {
                                process.exit(1);
                            }
                            throw err;
                        });
                        if (!waitend) return [3 /*break*/, 5];
                        defer = ioc.PromiseUtil.defer();
                        next.once('end', defer.resolve);
                        return [4 /*yield*/, defer.promise];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, next];
                }
            });
        });
    };
    TransformActivity.ρAnn = function () {
        return { "name": "TransformActivity" };
    };
    return TransformActivity;
}(NodeActivity_1.NodeActivity));
exports.TransformActivity = TransformActivity;


});

unwrapExports(TransformActivity_1);
var TransformActivity_2 = TransformActivity_1.TransformActivity;

var AnnotationActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationActivity = void 0;





var AnnotationActivity = /** @class */ (function (_super) {
    tslib.__extends(AnnotationActivity, _super);
    function AnnotationActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnotationActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var enable;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.annotation)];
                    case 1:
                        enable = _a.sent();
                        if (!enable) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.pipeStream(ctx, ctx.getData(), this.framework)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AnnotationActivity.ρAnn = function () {
        return { "name": "AnnotationActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input('annotationFramework', annotations.classAnnotations),
        tslib.__metadata("design:type", Object)
    ], AnnotationActivity.prototype, "framework", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], AnnotationActivity.prototype, "annotation", void 0);
    AnnotationActivity = tslib.__decorate([
        activities.Task('annotation')
    ], AnnotationActivity);
    return AnnotationActivity;
}(TransformActivity_1.TransformActivity));
exports.AnnotationActivity = AnnotationActivity;


});

unwrapExports(AnnotationActivity_1);
var AnnotationActivity_2 = AnnotationActivity_1.AnnotationActivity;

var UglifyActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.UglifyActivity = void 0;




var uglify = gulpUglifyEs.default;
var UglifyActivity = /** @class */ (function (_super) {
    tslib.__extends(UglifyActivity, _super);
    function UglifyActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UglifyActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var options;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.options)];
                    case 1:
                        options = _a.sent();
                        return [2 /*return*/, ctx.getData().pipe(options ? uglify(options) : uglify())];
                }
            });
        });
    };
    UglifyActivity.ρAnn = function () {
        return { "name": "UglifyActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input('uglifyOptions'),
        tslib.__metadata("design:type", Object)
    ], UglifyActivity.prototype, "options", void 0);
    UglifyActivity = tslib.__decorate([
        activities.Task('uglify, [uglify]')
    ], UglifyActivity);
    return UglifyActivity;
}(TransformActivity_1.TransformActivity));
exports.UglifyActivity = UglifyActivity;


});

unwrapExports(UglifyActivity_1);
var UglifyActivity_2 = UglifyActivity_1.UglifyActivity;

var JsonEditActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonReplaceActivity = exports.JsonEditActivity = void 0;








/**
 * edit json, will format new json string.
 *
 * @export
 * @class JsonEditActivity
 * @extends {TransformActivity}
 */
var JsonEditActivity = /** @class */ (function (_super) {
    tslib.__extends(JsonEditActivity, _super);
    function JsonEditActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonEditActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var jsonFunc_1;
            return tslib.__generator(this, function (_a) {
                if (!this.json) {
                    return [2 /*return*/];
                }
                if (ioc.isFunction(this.json)) {
                    jsonFunc_1 = this.json;
                    return [2 /*return*/, gulpJsonEditor(function (json) { return jsonFunc_1(json); })];
                }
                else {
                    return [2 /*return*/, gulpJsonEditor(this.json)];
                }
            });
        });
    };
    JsonEditActivity.ρAnn = function () {
        return { "name": "JsonEditActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], JsonEditActivity.prototype, "json", void 0);
    JsonEditActivity = tslib.__decorate([
        activities.Task('jsonEdit')
    ], JsonEditActivity);
    return JsonEditActivity;
}(TransformActivity_1.TransformActivity));
exports.JsonEditActivity = JsonEditActivity;
/**
 * replace json value of key. no format.
 *
 * @export
 * @class JsonReplaceActivity
 * @extends {TransformActivity}
 */
var JsonReplaceActivity = /** @class */ (function (_super) {
    tslib.__extends(JsonReplaceActivity, _super);
    function JsonReplaceActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonReplaceActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var fields;
            return tslib.__generator(this, function (_a) {
                fields = this.fields;
                if (!ioc.isFunction(fields)) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, through2.obj(function (file, encoding, callback) {
                        if (file.isNull()) {
                            return callback(null, file);
                        }
                        if (file.isStream()) {
                            return callback('doesn\'t support Streams');
                        }
                        var contents = file.contents.toString('utf8');
                        var json = JSON.parse(contents);
                        var replaced = jsonInPlace(contents);
                        var changs = fields(json);
                        if (changs instanceof Map) {
                            changs.forEach(function (val, key) {
                                replaced.set(key, val);
                            });
                        }
                        else {
                            ioc.lang.forIn(fields(json), function (val, key) {
                                replaced.set(key, val);
                            });
                        }
                        contents = replaced.toString();
                        file.contents = Buffer.from(contents);
                        callback(null, file);
                    })];
            });
        });
    };
    JsonReplaceActivity.ρAnn = function () {
        return { "name": "JsonReplaceActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Function)
    ], JsonReplaceActivity.prototype, "fields", void 0);
    JsonReplaceActivity = tslib.__decorate([
        activities.Task('jsonReplace')
    ], JsonReplaceActivity);
    return JsonReplaceActivity;
}(TransformActivity_1.TransformActivity));
exports.JsonReplaceActivity = JsonReplaceActivity;


});

unwrapExports(JsonEditActivity_1);
var JsonEditActivity_2 = JsonEditActivity_1.JsonReplaceActivity;
var JsonEditActivity_3 = JsonEditActivity_1.JsonEditActivity;

var AssetActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetActivity = void 0;





var AssetActivity = /** @class */ (function () {
    function AssetActivity() {
    }
    AssetActivity.ρAnn = function () {
        return { "name": "AssetActivity", "params": {} };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], AssetActivity.prototype, "src", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], AssetActivity.prototype, "dist", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], AssetActivity.prototype, "sourcemap", void 0);
    tslib.__decorate([
        components.Input('sourceMapFramework'),
        tslib.__metadata("design:type", Object)
    ], AssetActivity.prototype, "framework", void 0);
    tslib.__decorate([
        components.Input('pipes'),
        tslib.__metadata("design:type", Array)
    ], AssetActivity.prototype, "pipes", void 0);
    AssetActivity = tslib.__decorate([
        activities.Task({
            selector: 'asset',
            template: [
                {
                    activity: 'src',
                    src: 'binding: src'
                },
                {
                    activity: activities.Activities.if,
                    condition: 'binding: sourcemap',
                    body: {
                        name: 'sourcemap-init',
                        activity: activities.Activities.execute,
                        action: function (ctx, bind) {
                            var framework = bind.getScope().framework || gulpSourcemaps;
                            return ctx.getData().pipe(framework.init());
                        }
                    }
                },
                {
                    activity: 'pipes',
                    pipes: 'binding: pipes'
                },
                {
                    activity: activities.Activities.if,
                    condition: 'binding: sourcemap',
                    body: {
                        name: 'sourcemap-write',
                        activity: activities.Activities.execute,
                        action: function (ctx, bind) {
                            var scope = bind.getScope();
                            var framework = scope.framework || gulpSourcemaps;
                            return ctx.getData().pipe(framework.write(ioc.isString(scope.sourcemap) ? scope.sourcemap : './sourcemaps'));
                        }
                    }
                },
                {
                    activity: 'dist',
                    dist: 'binding: dist',
                }
            ]
        })
    ], AssetActivity);
    return AssetActivity;
}());
exports.AssetActivity = AssetActivity;


});

unwrapExports(AssetActivity_1);
var AssetActivity_2 = AssetActivity_1.AssetActivity;

var DestActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestActivity = void 0;





/**
 * source stream to dist activity.
 *
 * @export
 * @class DestActivity
 * @extends {TransformActivity}
 */
var DestActivity = /** @class */ (function (_super) {
    tslib.__extends(DestActivity, _super);
    function DestActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DestActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var dist, options;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.dist)];
                    case 1:
                        dist = _a.sent();
                        if (!dist) return [3 /*break*/, 4];
                        return [4 /*yield*/, ctx.resolveExpression(this.options)];
                    case 2:
                        options = _a.sent();
                        dist = ctx.platform.toRootPath(dist);
                        return [4 /*yield*/, this.pipeStream(ctx, ctx.getData(), options ? vinylFs.dest(dist, options) : vinylFs.dest(dist), this.end !== false)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DestActivity.ρAnn = function () {
        return { "name": "DestActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Boolean)
    ], DestActivity.prototype, "end", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], DestActivity.prototype, "dist", void 0);
    tslib.__decorate([
        components.Input('destOptions'),
        tslib.__metadata("design:type", Object)
    ], DestActivity.prototype, "options", void 0);
    DestActivity = tslib.__decorate([
        activities.Task('dist, [dist]')
    ], DestActivity);
    return DestActivity;
}(TransformActivity_1.TransformActivity));
exports.DestActivity = DestActivity;


});

unwrapExports(DestActivity_1);
var DestActivity_2 = DestActivity_1.DestActivity;

var SourceActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceActivity = void 0;





/**
 * Source activity.
 *
 * @export
 * @class SourceActivity
 * @extends {TransformActivity}
 */
var SourceActivity = /** @class */ (function (_super) {
    tslib.__extends(SourceActivity, _super);
    function SourceActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SourceActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var strSrc, options;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.src)];
                    case 1:
                        strSrc = _a.sent();
                        if (!strSrc) return [3 /*break*/, 3];
                        return [4 /*yield*/, ctx.resolveExpression(this.options)];
                    case 2:
                        options = _a.sent();
                        return [2 /*return*/, vinylFs.src(ctx.platform.normalizeSrc(strSrc), Object.assign({ cwd: ctx.platform.getRootPath() }, options || {}))];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SourceActivity.ρAnn = function () {
        return { "name": "SourceActivity", "params": { "execute": ["ctx"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], SourceActivity.prototype, "src", void 0);
    tslib.__decorate([
        components.Input('srcOptions'),
        tslib.__metadata("design:type", Object)
    ], SourceActivity.prototype, "options", void 0);
    SourceActivity = tslib.__decorate([
        activities.Task('src, [src]')
    ], SourceActivity);
    return SourceActivity;
}(TransformActivity_1.TransformActivity));
exports.SourceActivity = SourceActivity;


});

unwrapExports(SourceActivity_1);
var SourceActivity_2 = SourceActivity_1.SourceActivity;

var StreamActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamActivity = void 0;





var StreamActivity = /** @class */ (function (_super) {
    tslib.__extends(StreamActivity, _super);
    function StreamActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StreamActivity.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var pipes;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.pipes)];
                    case 1:
                        pipes = _a.sent();
                        if (ioc.isArray(pipes)) {
                            pipes = pipes.filter(function (p) { return p; });
                        }
                        if (!(pipes && pipes.length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.pipeStreams.apply(this, tslib.__spreadArrays([ctx, ctx.getData()], pipes))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * stream pipe transform.
     *
     * @protected
     * @param {NodeActivityContext} ctx
     * @param {ITransform} stream
     * @param {...Expression<ITransform>[]} pipes
     * @returns {Promise<ITransform>}
     * @memberof StreamActivity
     */
    StreamActivity.prototype.pipeStreams = function (ctx, stream) {
        var pipes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            pipes[_i - 2] = arguments[_i];
        }
        return tslib.__awaiter(this, void 0, void 0, function () {
            var pstream;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (pipes.length < 1) {
                            return [2 /*return*/, stream];
                        }
                        if (!(pipes.length === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.pipeStream(ctx, stream, pipes[0])];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        pstream = Promise.resolve(stream);
                        pipes.forEach(function (transform) {
                            if (transform) {
                                pstream = pstream
                                    .then(function (stm) {
                                    return _this.pipeStream(ctx, stm, transform);
                                });
                            }
                        });
                        return [4 /*yield*/, pstream];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StreamActivity.ρAnn = function () {
        return { "name": "StreamActivity", "params": { "execute": ["ctx"], "pipeStreams": ["ctx", "stream", "pipes"] } };
    };
    tslib.__decorate([
        components.Input('pipes'),
        tslib.__metadata("design:type", Array)
    ], StreamActivity.prototype, "pipes", void 0);
    StreamActivity = tslib.__decorate([
        activities.Task('pipes, [pipes]')
    ], StreamActivity);
    return StreamActivity;
}(TransformActivity_1.TransformActivity));
exports.StreamActivity = StreamActivity;


});

unwrapExports(StreamActivity_1);
var StreamActivity_2 = StreamActivity_1.StreamActivity;

var TsBuildActivity_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsBuildActivity = void 0;








var TsBuildActivity = /** @class */ (function (_super) {
    tslib.__extends(TsBuildActivity, _super);
    function TsBuildActivity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TsBuildActivity.ρAnn = function () {
        return { "name": "TsBuildActivity", "params": {} };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TsBuildActivity.prototype, "dts", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TsBuildActivity.prototype, "annotation", void 0);
    tslib.__decorate([
        components.Input('annotationFramework'),
        tslib.__metadata("design:type", Object)
    ], TsBuildActivity.prototype, "annotationFramework", void 0);
    tslib.__decorate([
        components.Input('beforePipes'),
        tslib.__metadata("design:type", Array)
    ], TsBuildActivity.prototype, "beforePipes", void 0);
    tslib.__decorate([
        components.Input('tsconfig', './tsconfig.json'),
        tslib.__metadata("design:type", Object)
    ], TsBuildActivity.prototype, "tsconfig", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TsBuildActivity.prototype, "uglify", void 0);
    tslib.__decorate([
        components.Input('uglifyOptions'),
        tslib.__metadata("design:type", Object)
    ], TsBuildActivity.prototype, "uglifyOptions", void 0);
    TsBuildActivity = tslib.__decorate([
        activities.Task({
            selector: 'ts',
            template: [
                {
                    activity: 'src',
                    src: 'binding: src',
                },
                {
                    activity: 'annotation',
                    annotationFramework: 'binding: annotationFramework',
                    annotation: 'binding: annotation'
                },
                {
                    activity: activities.Activities.if,
                    condition: 'binding: sourcemap',
                    body: {
                        name: 'sourcemap-init',
                        activity: activities.Activities.execute,
                        action: function (ctx, bind) {
                            var scope = bind.getScope();
                            var framework = scope.framework || gulpSourcemaps;
                            return ctx.getData().pipe(framework.init());
                        }
                    }
                },
                {
                    activity: activities.Activities.if,
                    condition: function (ctx, bind) { var _a; return ((_a = bind.getScope().beforePipes) === null || _a === void 0 ? void 0 : _a.length) > 0; },
                    body: {
                        activity: 'pipes',
                        pipes: 'binding: beforePipes'
                    }
                },
                {
                    activity: activities.Activities.execute,
                    name: 'tscompile',
                    action: function (ctx, bind) { return tslib.__awaiter(void 0, void 0, void 0, function () {
                        var scope, tsconfig, tsCompile, dts, tsProject, tsProject;
                        return tslib.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    scope = bind.getScope();
                                    if (!scope.tsconfig) {
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, ctx.resolveExpression(scope.tsconfig)];
                                case 1:
                                    tsconfig = _a.sent();
                                    return [4 /*yield*/, ctx.resolveExpression(scope.dts)];
                                case 2:
                                    dts = _a.sent();
                                    if (ioc.isString(tsconfig)) {
                                        tsProject = gulpTypescript.createProject(ctx.platform.relativeRoot(tsconfig), { declaration: !!dts });
                                        tsCompile = tsProject();
                                    }
                                    else {
                                        tsconfig.declaration = !!dts;
                                        tsProject = gulpTypescript.createProject(ctx.platform.relativeRoot('./tsconfig.json'), tsconfig);
                                        tsCompile = tsProject();
                                    }
                                    return [2 /*return*/, ctx.getData().pipe(tsCompile)];
                            }
                        });
                    }); }
                },
                {
                    activity: activities.Activities.if,
                    externals: {
                        data: 'ctx.getData() | tsjs'
                    },
                    condition: function (ctx) { return ITransform.isTransform(ctx.getData()); },
                    body: [
                        {
                            activity: 'pipes',
                            pipes: 'binding: pipes'
                        },
                        {
                            activity: 'if',
                            condition: 'binding: uglify',
                            body: {
                                activity: 'uglify',
                                uglifyOptions: 'binding: uglifyOptions'
                            }
                        },
                        {
                            activity: activities.Activities.if,
                            condition: 'binding: sourcemap',
                            body: {
                                name: 'sourcemap-write',
                                activity: activities.Activities.execute,
                                action: function (ctx, bind) { return tslib.__awaiter(void 0, void 0, void 0, function () {
                                    var scope, framework;
                                    return tslib.__generator(this, function (_a) {
                                        scope = bind.getScope();
                                        framework = scope.framework || gulpSourcemaps;
                                        return [2 /*return*/, ctx.getData().pipe(framework.write(ioc.isString(scope.sourcemap) ? scope.sourcemap : './sourcemaps'))];
                                    });
                                }); }
                            }
                        },
                        {
                            name: 'write-js',
                            activity: 'dist',
                            dist: 'binding: dist'
                        }
                    ]
                },
                {
                    activity: activities.Activities.if,
                    externals: {
                        data: 'ctx.getData() | dts'
                    },
                    condition: 'binding: dts',
                    body: {
                        name: 'write-dts',
                        activity: 'dist',
                        dist: 'binding: dts'
                    }
                }
            ]
        })
    ], TsBuildActivity);
    return TsBuildActivity;
}(AssetActivity_1.AssetActivity));
exports.TsBuildActivity = TsBuildActivity;


});

unwrapExports(TsBuildActivity_1);
var TsBuildActivity_2 = TsBuildActivity_1.TsBuildActivity;

var transforms = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib.__exportStar(TransformActivity_1, exports);
tslib.__exportStar(AnnotationActivity_1, exports);
tslib.__exportStar(UglifyActivity_1, exports);
tslib.__exportStar(JsonEditActivity_1, exports);
tslib.__exportStar(AssetActivity_1, exports);
tslib.__exportStar(DestActivity_1, exports);
tslib.__exportStar(SourceActivity_1, exports);
tslib.__exportStar(StreamActivity_1, exports);
tslib.__exportStar(TsBuildActivity_1, exports);


});

unwrapExports(transforms);

var BuilderTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


});

unwrapExports(BuilderTypes);

var LibPackBuilder_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibPackBuilder = void 0;











var uglify = gulpUglifyEs.default;
var LibPackBuilder = /** @class */ (function () {
    function LibPackBuilder() {
    }
    LibPackBuilder.prototype.toOutputPath = function () {
        var mdpath = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            mdpath[_i] = arguments[_i];
        }
        return path.join.apply(void 0, tslib.__spreadArrays([this.outDir], mdpath.filter(function (f) { return f; })));
    };
    LibPackBuilder.prototype.toModulePath = function (input) {
        var paths = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            paths[_i - 1] = arguments[_i];
        }
        return path.join.apply(void 0, tslib.__spreadArrays([
            this.outDir,
            this.getModuleFolder(input)
        ], paths.filter(function (f) { return f; })));
    };
    LibPackBuilder.prototype.getTargetPath = function (input) {
        return this.toOutputPath(this.getTargetFolder(input));
    };
    LibPackBuilder.prototype.getTargetFolder = function (input) {
        return input.targetFolder || input.target;
    };
    LibPackBuilder.prototype.getModuleFolder = function (input) {
        return input.moduleFolder || (ioc.isArray(input.moduleName) ? ioc.lang.first(input.moduleName) : input.moduleName);
    };
    LibPackBuilder.prototype.transRollupInput = function (input) {
        var _this = this;
        var inputs = input.input;
        return ioc.isArray(inputs) ? inputs.map(function (i) { return _this.toOutputPath(i); }) : this.toOutputPath(inputs);
    };
    LibPackBuilder.prototype.transRollupoutput = function (input) {
        return {
            format: input.format || 'cjs',
            file: input.outputFile ? this.toModulePath(input, input.outputFile) : undefined,
            dir: input.outputFile ? undefined : this.toModulePath(input),
        };
    };
    LibPackBuilder.prototype.transCompileOptions = function (input) {
        if (input.target) {
            return input.module ? { target: input.target, module: input.module } : { target: input.target };
        }
        return {};
    };
    LibPackBuilder.prototype.getDtsPath = function (input) {
        var targetpath = this.getTargetPath(input);
        return this.dts ? path.join(targetpath, this.dts) : (input.dtsMain ? targetpath : null);
    };
    LibPackBuilder.prototype.transPlugins = function (ctx) {
        var beforeResolve = this.beforeResolve || [];
        var sourcemap = this.sourcemap;
        var input = ctx.getInput();
        return this.plugins ? tslib.__spreadArrays(beforeResolve, this.plugins, [
            sourcemap ? rollupPluginSourcemaps(ioc.isBoolean(sourcemap) ? undefined : sourcemap) : null
        ]) : tslib.__spreadArrays(beforeResolve, [
            rollupPluginNodeResolve({ browser: input.format === 'umd' }),
            rollupPluginCommonjs({ extensions: ['.js', '.ts', '.tsx'] }),
            sourcemap ? rollupPluginSourcemaps(ioc.isBoolean(sourcemap) ? undefined : sourcemap) : null
        ]);
    };
    LibPackBuilder.prototype.getBundleSrc = function (input) {
        return ioc.isArray(input.input) ? this.toModulePath(input, '/**/*.js') : this.toModulePath(input, input.outputFile);
    };
    LibPackBuilder.prototype.json = function (json, input) {
        // to replace module export.
        if (input.target) {
            json[input.target] = ['.', this.getTargetFolder(input), input.main || 'index.js'].join('/');
        }
        var outmain = ['.', this.getModuleFolder(input), input.outputFile || 'index.js'].join('/');
        if (ioc.isArray(input.moduleName)) {
            input.moduleName.forEach(function (n) {
                json[n] = outmain;
            });
        }
        else if (input.moduleName) {
            json[input.moduleName] = outmain;
        }
        if (input.dtsMain) {
            json['typings'] = ['.', this.getTargetFolder(input), input.dtsMain].join('/');
        }
        return json;
    };
    LibPackBuilder.prototype.onAfterInit = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var func_1;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                if (!this.external) {
                    func_1 = function (ctx) {
                        var packagejson = ctx.platform.getPackage();
                        var external = tslib.__spreadArrays([
                            'process', 'util', 'path', 'fs', 'events', 'stream', 'child_process', 'os',
                            'https', 'http', 'url', 'crypto'
                        ], (_this.externalLibs || []), Object.keys(packagejson.dependencies || {}), Object.keys(packagejson.peerDependencies || {}));
                        if (external.indexOf('rxjs')) {
                            external.push('rxjs/operators');
                        }
                        if (_this.includeLib && _this.includeLib.length) {
                            external = external.filter(function (ex) { return _this.includeLib.indexOf(ex) < 0; });
                        }
                        return external;
                    };
                    this.external = function (ctx) {
                        return func_1(ctx);
                    };
                }
                return [2 /*return*/];
            });
        });
    };
    LibPackBuilder.ρAnn = function () {
        return { "name": "LibPackBuilder", "params": { "toOutputPath": ["mdpath"], "toModulePath": ["input", "paths"], "getTargetPath": ["input"], "getTargetFolder": ["input"], "getModuleFolder": ["input"], "transRollupInput": ["input"], "transRollupoutput": ["input"], "transCompileOptions": ["input"], "getDtsPath": ["input"], "transPlugins": ["ctx"], "getBundleSrc": ["input"], "json": ["json", "input"] } };
    };
    tslib.__decorate([
        ioc.Inject(),
        tslib.__metadata("design:type", PlatformService_1.PlatformService)
    ], LibPackBuilder.prototype, "platform", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "src", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "test", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], LibPackBuilder.prototype, "bundles", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", String)
    ], LibPackBuilder.prototype, "outDir", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Boolean)
    ], LibPackBuilder.prototype, "annotation", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", String)
    ], LibPackBuilder.prototype, "dts", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "external", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], LibPackBuilder.prototype, "externalLibs", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], LibPackBuilder.prototype, "includeLib", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], LibPackBuilder.prototype, "plugins", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "globals", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "cache", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "watch", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], LibPackBuilder.prototype, "replaces", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "options", void 0);
    tslib.__decorate([
        components.Input({ defaultValue: true }),
        tslib.__metadata("design:type", Object)
    ], LibPackBuilder.prototype, "sourcemap", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Array)
    ], LibPackBuilder.prototype, "beforeResolve", void 0);
    LibPackBuilder = tslib.__decorate([
        activities.Task({
            selector: 'libs',
            template: [
                {
                    activity: 'clean',
                    clean: 'binding: outDir'
                },
                {
                    activity: 'test',
                    test: 'binding: test',
                },
                {
                    activity: 'asset',
                    src: ['package.json', '*.md'],
                    dist: 'binding: outDir'
                },
                {
                    activity: 'each',
                    each: 'binding: bundles',
                    body: [
                        {
                            activity: activities.Activities.if,
                            condition: function (ctx) { return ctx.getInput().target; },
                            body: {
                                activity: 'ts',
                                src: 'binding: src',
                                dist: function (ctx, bind) { return bind.getScope().getTargetPath(ctx.getInput()); },
                                dts: function (ctx, bind) { return bind.getScope().getDtsPath(ctx.getInput()); },
                                annotation: 'binding: annotation',
                                sourcemap: 'binding: sourcemap',
                                pipes: function (ctx, bind) {
                                    var replaces = bind.getScope().replaces;
                                    if (ctx.getInput().format == 'es' && replaces && replaces.length) {
                                        return [
                                            function () { return through2.obj(function (file, encoding, callback) {
                                                if (file.isNull()) {
                                                    return callback(null, file);
                                                }
                                                if (file.isStream()) {
                                                    return callback('doesn\'t support Streams');
                                                }
                                                var contents = file.contents.toString('utf8');
                                                replaces.forEach(function (r) {
                                                    contents = contents.replace(r[0], r[1]);
                                                });
                                                file.contents = new Buffer(contents, 'utf-8');
                                                this.push(file);
                                                callback();
                                            }); }
                                        ];
                                    }
                                    return [];
                                },
                                tsconfig: function (ctx, bind) { return bind.getScope().transCompileOptions(ctx.getInput()); }
                            }
                        },
                        {
                            activity: activities.Activities.if,
                            condition: function (ctx) { return ctx.getInput().input; },
                            body: [
                                {
                                    activity: 'rollup',
                                    input: function (ctx, bind) { return bind.getScope().transRollupInput(ctx.getInput()); },
                                    sourcemap: 'binding: sourcemap',
                                    plugins: function (ctx, bind) { return bind.getScope().transPlugins(ctx); },
                                    external: 'binding: external',
                                    options: 'binding: options',
                                    globals: 'binding: globals',
                                    output: function (ctx, bind) { return bind.getScope().transRollupoutput(ctx.getInput()); }
                                },
                                {
                                    activity: activities.Activities.if,
                                    condition: function (ctx, bind) { return bind.getInput().uglify; },
                                    body: {
                                        activity: 'asset',
                                        src: function (ctx, bind) { return bind.getScope().getBundleSrc(ctx.getInput()); },
                                        dist: function (ctx, bind) { return bind.getScope().toModulePath(bind.getInput()); },
                                        sourcemap: 'binding: sourcemap | path:"./"',
                                        pipes: [
                                            function () { return uglify(); },
                                            function () { return gulpRename({ suffix: '.min' }); }
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            activity: activities.Activities.if,
                            condition: function (ctx) { return ctx.getInput().moduleName || ctx.getInput().target; },
                            body: {
                                activity: 'asset',
                                src: function (ctx, bind) { return bind.getScope().toOutputPath('package.json'); },
                                dist: 'binding: outDir',
                                pipes: [
                                    {
                                        activity: 'jsonEdit',
                                        json: function (json, bind) {
                                            var input = bind.getInput();
                                            var scope = bind.getScope();
                                            // to replace module export.
                                            if (input.target) {
                                                json[input.target] = ['.', scope.getTargetFolder(input), input.main || 'index.js'].join('/');
                                            }
                                            var outmain = ['.', scope.getModuleFolder(input), input.outputFile || 'index.js'].join('/');
                                            if (ioc.isArray(input.moduleName)) {
                                                input.moduleName.forEach(function (n) {
                                                    json[n] = outmain;
                                                });
                                            }
                                            else if (input.moduleName) {
                                                json[input.moduleName] = outmain;
                                            }
                                            if (input.dtsMain) {
                                                json['typings'] = ['.', scope.getTargetFolder(input), input.dtsMain].join('/');
                                            }
                                            return json;
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            ]
            // template: `
            //     <clean [clean]="outDir"></clean>
            //     <test [test]="outDir"></test>
            //     <asset [src]="['package.json', '*.md']" [test]="outDir"></asset>
            //     <sequence *each="let input in bundles">
            //         <rts *if="vaidts(input)" [input]="transRollupInput(input)" [sourcemap]="sourcemap" [plugins]="transPlugins(ctx)" [external]="external"
            //                 [options]="options" [globals]="globals" [output]="transRollupoutput(input)"></rts>
            //         <rollup *elseif="input" [input]="transRollupInput(input)" [sourcemap]="sourcemap" [plugins]="transPlugins(ctx)" [external]="external"
            //                 [options]="options" [globals]="globals" [output]="transRollupoutput(input)"></rollup>
            //         <asset *if="input.uglify" [src]="getBundleSrc(input)" [dist]="toModulePath(input)" [sourcemap]="sourcemap | path:'./'" ></asset>
            //         <asset *if="input.moduleName || input.target" [src]="toOutputPath('package.json')" [dist]="outDir">
            //             <asset.pipes>
            //                 <jsonEdit [json]="json($event, input)"></jsonEdit>
            //             </asset.pipes>
            //         </asset>
            //     </sequence>
            // `
        }),
        tslib.__metadata("design:paramtypes", [])
    ], LibPackBuilder);
    return LibPackBuilder;
}());
exports.LibPackBuilder = LibPackBuilder;


});

unwrapExports(LibPackBuilder_1);
var LibPackBuilder_2 = LibPackBuilder_1.LibPackBuilder;

var TsLibPackBuilder_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TsLibPackBuilder = void 0;







var uglify = gulpUglifyEs.default;
/**
 * build ts project by rollup
 *
 * @export
 * @class TsLibPackBuilder
 * @extends {LibPackBuilder}
 * @implements {AfterInit}
 */
var TsLibPackBuilder = /** @class */ (function (_super) {
    tslib.__extends(TsLibPackBuilder, _super);
    function TsLibPackBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TsLibPackBuilder.prototype.vaidts = function (input) {
        var inputs = input.input || this.mainFile;
        if (inputs) {
            return ioc.isArray(inputs) ? inputs.some(function (i) { return exps.tsFileExp.test(i); }) : exps.tsFileExp.test(inputs);
        }
        return false;
    };
    TsLibPackBuilder.ρAnn = function () {
        return { "name": "TsLibPackBuilder", "params": { "vaidts": ["input"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", String)
    ], TsLibPackBuilder.prototype, "mainFile", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TsLibPackBuilder.prototype, "beforeCompile", void 0);
    TsLibPackBuilder = tslib.__decorate([
        activities.Task({
            selector: 'tslibs',
            template: [
                {
                    activity: 'clean',
                    clean: 'binding: outDir'
                },
                {
                    activity: 'test',
                    test: 'binding: test',
                },
                {
                    activity: 'asset',
                    src: ['package.json', '*.md'],
                    dist: 'binding: outDir'
                },
                {
                    activity: 'each',
                    each: 'binding: bundles',
                    body: [
                        {
                            activity: activities.Activities.if,
                            condition: function (ctx, bind) { return bind.getScope().vaidts(ctx.getInput()); },
                            body: {
                                activity: 'rts',
                                input: function (ctx, bind) { return bind.getScope().transRollupInput(ctx.getInput()); },
                                sourcemap: 'binding: sourcemap',
                                plugins: function (ctx, bind) { return bind.getScope().transPlugins(ctx); },
                                external: 'binding: external',
                                options: 'binding: options',
                                globals: 'binding: globals',
                                output: function (ctx, bind) { return bind.getScope().transRollupoutput(ctx.getInput()); }
                            }
                        },
                        {
                            activity: activities.Activities.elseif,
                            condition: function (ctx) { return ctx.getInput().input; },
                            body: {
                                activity: 'rollup',
                                input: function (ctx, bind) { return bind.getScope().transRollupInput(ctx.getInput()); },
                                sourcemap: 'binding: sourcemap',
                                plugins: 'binding: transPlugins(ctx)',
                                external: 'binding: external',
                                options: 'binding: options',
                                globals: 'binding: globals',
                                output: function (ctx, bind) { return bind.getScope().transRollupoutput(ctx.getInput()); }
                            }
                        },
                        {
                            activity: activities.Activities.if,
                            condition: function (ctx) { return ctx.getInput().uglify; },
                            body: {
                                activity: 'asset',
                                src: function (ctx, bind) { return bind.getScope().getBundleSrc(ctx.getInput()); },
                                dist: function (ctx, bind) { return bind.getScope().toModulePath(bind.getInput()); },
                                sourcemap: 'binding: sourcemap | path:"./"',
                                pipes: [
                                    function () { return uglify(); },
                                    function () { return gulpRename({ suffix: '.min' }); }
                                ]
                            }
                        },
                        {
                            activity: activities.Activities.if,
                            condition: function (ctx) { return ctx.getInput().moduleName || ctx.getInput().target; },
                            body: {
                                activity: 'asset',
                                src: function (ctx, bind) { return bind.getScope().toOutputPath('package.json'); },
                                dist: 'binding: outDir',
                                pipes: [
                                    {
                                        activity: 'jsonEdit',
                                        json: function (json, bind) {
                                            var input = bind.getInput();
                                            var scope = bind.getScope();
                                            // to replace module export.
                                            if (input.target) {
                                                json[input.target] = ['.', scope.getTargetFolder(input), input.main || 'index.js'].join('/');
                                            }
                                            var outmain = ['.', scope.getModuleFolder(input), input.outputFile || 'index.js'].join('/');
                                            if (ioc.isArray(input.moduleName)) {
                                                input.moduleName.forEach(function (n) {
                                                    json[n] = outmain;
                                                });
                                            }
                                            else if (input.moduleName) {
                                                json[input.moduleName] = outmain;
                                            }
                                            if (input.dtsMain) {
                                                json['typings'] = ['.', scope.getTargetFolder(input), input.dtsMain].join('/');
                                            }
                                            return json;
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            ]
            // template: `
            // <clean [clean]="outDir"></clean>
            // <test [test]="outDir"></test>
            // <asset [src]="['package.json', '*.md']" [test]="outDir"></asset>
            // <sequence *each="let input in bundles">
            //     <rts *if="vaidts(input)" [input]="transRollupInput(input)" [sourcemap]="sourcemap" [plugins]="transPlugins(ctx)" [external]="external"
            //             [options]="options" [globals]="globals" [output]="transRollupoutput(input)"></rts>
            //     <rollup *elseif="input" [input]="transRollupInput(input)" [sourcemap]="sourcemap" [plugins]="transPlugins(ctx)" [external]="external"
            //             [options]="options" [globals]="globals" [output]="transRollupoutput(input)"></rollup>
            //     <asset *if="input.uglify" [src]="getBundleSrc(input)" [dist]="toModulePath(input)" [sourcemap]="sourcemap | path:'./'" ></asset>
            //     <asset *if="input.moduleName || input.target" [src]="toOutputPath('package.json')" [dist]="outDir">
            //         <asset.pipes>
            //             <jsonEdit [json]="json($event, input)"></jsonEdit>
            //         </asset.pipes>
            //     </asset>
            // </sequence>
            // `
        })
    ], TsLibPackBuilder);
    return TsLibPackBuilder;
}(LibPackBuilder_1.LibPackBuilder));
exports.TsLibPackBuilder = TsLibPackBuilder;


});

unwrapExports(TsLibPackBuilder_1);
var TsLibPackBuilder_2 = TsLibPackBuilder_1.TsLibPackBuilder;

var TscBuilder_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TscBuilder = void 0;




var jsChkExp = /.js/;
var TscBuilder = /** @class */ (function (_super) {
    tslib.__extends(TscBuilder, _super);
    function TscBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TscBuilder.prototype.execute = function (ctx) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var compilerOptions, src, srcFiles, dist, tsconfig, shell;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ctx.resolveExpression(this.compilerOptions)];
                    case 1:
                        compilerOptions = _a.sent();
                        compilerOptions = compilerOptions || {};
                        return [4 /*yield*/, ctx.resolveExpression(this.src)];
                    case 2:
                        src = _a.sent();
                        src = src || compilerOptions.sourceRoot;
                        if (!src) return [3 /*break*/, 4];
                        return [4 /*yield*/, ctx.platform.getFiles(src)];
                    case 3:
                        srcFiles = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, ctx.resolveExpression(this.dist)];
                    case 5:
                        dist = _a.sent();
                        if (dist) {
                            if (!jsChkExp.test(dist)) {
                                compilerOptions.outDir = dist;
                            }
                            else {
                                compilerOptions.outFile = dist;
                            }
                        }
                        return [4 /*yield*/, ctx.resolveExpression(this.tsconfig)];
                    case 6:
                        tsconfig = _a.sent();
                        shell = '';
                        if (tsconfig) {
                            shell = "tsc -p " + tsconfig;
                        }
                        else {
                            shell = "tsc " + this.formatCompileOptions(compilerOptions) + " " + srcFiles.join(' ');
                        }
                        return [4 /*yield*/, ctx.getExector().runActivity({
                                activity: 'shell',
                                parallel: true,
                                shell: shell,
                                options: { cwd: ctx.platform.getRootPath() }
                            })];
                    case 7: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TscBuilder.prototype.formatCompileOptions = function (options) {
        return '';
    };
    TscBuilder.ρAnn = function () {
        return { "name": "TscBuilder", "params": { "execute": ["ctx"], "formatCompileOptions": ["options"] } };
    };
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TscBuilder.prototype, "src", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TscBuilder.prototype, "dist", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TscBuilder.prototype, "tsconfig", void 0);
    tslib.__decorate([
        components.Input(),
        tslib.__metadata("design:type", Object)
    ], TscBuilder.prototype, "compilerOptions", void 0);
    TscBuilder = tslib.__decorate([
        activities.Task('tsc')
    ], TscBuilder);
    return TscBuilder;
}(NodeActivity_1.NodeActivity));
exports.TscBuilder = TscBuilder;


});

unwrapExports(TscBuilder_1);
var TscBuilder_2 = TscBuilder_1.TscBuilder;

var builds = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib.__exportStar(BuilderTypes, exports);
tslib.__exportStar(LibPackBuilder_1, exports);
tslib.__exportStar(TsLibPackBuilder_1, exports);
tslib.__exportStar(TscBuilder_1, exports);


});

unwrapExports(builds);

var TsPipe = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeScriptDtsPipe = exports.TypeScriptJsPipe = void 0;


var TypeScriptJsPipe = /** @class */ (function () {
    function TypeScriptJsPipe() {
    }
    TypeScriptJsPipe.prototype.transform = function (value) {
        var _a;
        return (_a = value.js) !== null && _a !== void 0 ? _a : value;
    };
    TypeScriptJsPipe.ρAnn = function () {
        return { "name": "TypeScriptJsPipe", "params": { "transform": ["value"] } };
    };
    TypeScriptJsPipe = tslib.__decorate([
        components.Pipe('tsjs')
    ], TypeScriptJsPipe);
    return TypeScriptJsPipe;
}());
exports.TypeScriptJsPipe = TypeScriptJsPipe;
var TypeScriptDtsPipe = /** @class */ (function () {
    function TypeScriptDtsPipe() {
    }
    TypeScriptDtsPipe.prototype.transform = function (value) {
        return value.dts;
    };
    TypeScriptDtsPipe.ρAnn = function () {
        return { "name": "TypeScriptDtsPipe", "params": { "transform": ["value"] } };
    };
    TypeScriptDtsPipe = tslib.__decorate([
        components.Pipe('dts')
    ], TypeScriptDtsPipe);
    return TypeScriptDtsPipe;
}());
exports.TypeScriptDtsPipe = TypeScriptDtsPipe;
// import { IPipeTransform, Pipe } from '@tsdi/components';
// import { ITransform } from '../ITransform';
// import { IActivityContext } from '@tsdi/activities';
// const filter = require('gulp-filter');
// const jsFilter = filter('**/*.js', { restore: true });
// const dtsFtr = filter('**/*.d.ts');
// const key = '__js_restore_filter';
// @Pipe('tsjs')
// export class TypeScriptJsPipe implements IPipeTransform {
//     transform(value: ITransform, env: { ctx: IActivityContext }): ITransform {
//         const fstm = value.pipe(jsFilter);
//         env.ctx.runScope?.setValue(key, jsFilter.restore);
//         return fstm;
//     }
// }
// @Pipe('dts')
// export class TypeScriptDtsPipe implements IPipeTransform {
//     transform(value: ITransform, env: { ctx: IActivityContext }): ITransform {
//         if (env.ctx.runScope?.hasValue(key)) {
//             value = value.pipe(env.ctx.runScope?.getValue<ITransform>(key));
//         }
//         return value.pipe(dtsFtr);
//     }
// }


});

unwrapExports(TsPipe);
var TsPipe_1 = TsPipe.TypeScriptDtsPipe;
var TsPipe_2 = TsPipe.TypeScriptJsPipe;

var vailfypipes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathPipe = void 0;



var PathPipe = /** @class */ (function () {
    function PathPipe() {
    }
    PathPipe.prototype.transform = function (value, defaults) {
        if (ioc.isString(value)) {
            return value;
        }
        return value ? defaults : null;
    };
    PathPipe.ρAnn = function () {
        return { "name": "PathPipe", "params": { "transform": ["value", "defaults"] } };
    };
    PathPipe = tslib.__decorate([
        components.Pipe('path')
    ], PathPipe);
    return PathPipe;
}());
exports.PathPipe = PathPipe;


});

unwrapExports(vailfypipes);
var vailfypipes_1 = vailfypipes.PathPipe;

var pipes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib.__exportStar(TsPipe, exports);
tslib.__exportStar(vailfypipes, exports);


});

unwrapExports(pipes);

var PackModule_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackModule = void 0;











var PackModule = /** @class */ (function () {
    function PackModule() {
    }
    PackModule.ρAnn = function () {
        return { "name": "PackModule", "params": {} };
    };
    PackModule = tslib.__decorate([
        boot.DIModule({
            regIn: 'root',
            imports: [
                platformServerBoot.ServerBootstrapModule,
            ],
            providers: [
                [pipes],
                tsComplie.TsComplie,
                NodeActivityContext_1.NodeActivityContext,
                PlatformService_1.PlatformService
            ],
            components: [
                tasks,
                rollups,
                transforms,
                builds
            ]
        })
    ], PackModule);
    return PackModule;
}());
exports.PackModule = PackModule;


});

unwrapExports(PackModule_1);
var PackModule_2 = PackModule_1.PackModule;

var templates = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


});

unwrapExports(templates);

var src = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

tslib.__exportStar(ITransform, exports);
tslib.__exportStar(IPlatformService, exports);
tslib.__exportStar(PlatformService_1, exports);
tslib.__exportStar(NodeActivity_1, exports);
tslib.__exportStar(NodeActivityContext_1, exports);
tslib.__exportStar(tasks, exports);
tslib.__exportStar(rollups, exports);
tslib.__exportStar(transforms, exports);
tslib.__exportStar(PackModule_1, exports);
tslib.__exportStar(templates, exports);
tslib.__exportStar(builds, exports);
tslib.__exportStar(tsComplie, exports);


});

var index = unwrapExports(src);

module.exports = index;
//# sourceMappingURL=pack.js.map
